package ai.jessie.web.authentication

import ai.jessie.web.theme.ButtonVariant
import ai.jessie.web.theme.linkButton
import ai.jessie.web.theme.themedButton
import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Form
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun authenticationSection(
    outcome: String?,
    state: AuthenticationSessionUiState,
    actions: AuthenticationSessionActions,
) {
    H2 { Text("Anmelden") }
    val message =
        when (outcome) {
            "cancelled" -> "Die Anmeldung wurde nicht abgeschlossen. Du kannst sie erneut starten."
            "rejected" -> "Die Anmeldung konnte nicht bestätigt werden. Starte sie erneut."
            "unavailable" ->
                "Die Anmeldung ist vorübergehend nicht verfügbar. Versuche es später erneut."
            else -> null
        }
    message?.let { P { Text(it) } }
    sessionStatus(state.status)
    if (state.status == SessionStatus.AUTHENTICATED) {
        P { Text("Die Abmeldung beendet auch deine Sitzung beim Anmeldedienst in diesem Browser.") }
        Form(action = "/api/v1/authentication/logout", attrs = { attr("method", "post") }) {
            themedButton("Abmelden", {}, submit = true)
        }
        Form(action = "/api/v1/authentication/logout-all", attrs = { attr("method", "post") }) {
            themedButton("Auf allen Geräten abmelden", {}, submit = true)
        }
    }
    if (state.status != SessionStatus.AUTHENTICATED || message != null) {
        P {
            linkButton(
                if (message == null) "Anmelden" else "Anmeldung erneut starten",
                "/api/v1/authentication/start",
                ButtonVariant.PRIMARY,
            )
        }
    }
    if (state.status == SessionStatus.UNAVAILABLE) {
        P { themedButton("Sitzung erneut prüfen", actions.refresh) }
    }
}

@Composable
private fun sessionStatus(status: SessionStatus) {
    Div(
        attrs = {
            attr("role", "status")
            attr("aria-live", "polite")
        }
    ) {
        P {
            Text(
                when (status) {
                    SessionStatus.CHECKING -> "Deine Jessie-Sitzung wird geprüft."
                    SessionStatus.AUTHENTICATED -> "Du bist bei Jessie angemeldet."
                    SessionStatus.UNAUTHENTICATED ->
                        "Du bist nicht bei Jessie angemeldet. Melde dich an, um fortzufahren."
                    SessionStatus.UNAVAILABLE ->
                        "Deine Jessie-Sitzung kann momentan nicht geprüft werden."
                }
            )
        }
    }
}
